function EmbededOnHead() {
  const infoShareData = {
    title: 'GamePiece Labs - Phụ Kiện BoardGame',
    description: 'Chuyên cung cấp các dịch vụ hỗ trợ Boardgame và thiết kế in 3D',
    urlImg: 'https://gamepiecelabs.io.vn/imgs/GamePiece_Labs_Share_fb.png',
    url: 'https://gamepiecelabs.io.vn/',
  };

  return (
    <head>
      <meta property="og:title" content={infoShareData.title} />
      <meta property="og:description" content={infoShareData.description} />
      <meta property="og:image" content={infoShareData.urlImg} />
      <meta property="og:url" content={infoShareData.url} />
      <meta property="og:type" content="website" />
    </head>
  );
}
export default EmbededOnHead;
